export default __webpack_public_path__ + "static/media/changeicon.65a1bf50.png";